import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Amplify, { Analytics } from 'aws-amplify';
import { withAlert } from 'react-alert';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import * as _ from 'lodash';
import Dropdown from 'react-dropdown';
// import { toast } from 'react-toastify';
import MaskInputNumber from '../../common/maskInputNumberProfile';
import loader from '../../../images/Spin-1s-107px.gif';
import 'react-toastify/dist/ReactToastify.css';

import TextFieldGroup from '../../common/TextFieldGroupProfile';
import * as SecretKeys from '../../../ENV.json';
import { submitSubUser, checkEmailVerify, getAllCountry, getAffiliateUser, submitSubUserClear } from '../../../Actions/actions';

Amplify.configure(SecretKeys.awsUserpool);

Analytics.disable();

class SubuserAffiliate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      firstname: '',
      lastname: '',
      phone: '',
      password: 'M' + Math.random().toString(36).slice(-3) + '@' + Math.random().toString(36).slice(-3) + '8',
      countryCode: '+1',
      errors: {},
      isLoading: false,
      failedLoginMessages: '',
      GetAffiliateSubUser1: [],
      saveProfileAState: false,
      isLoader: false,
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubUsers = this.handleSubUsers.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
    this.closeCompanyUserSub = this.closeCompanyUserSub.bind(this);
  }

  onChange(e) {
    this.setState({ errors: {}, isLoading: true, failedLoginMessages: '' });
    this.setState({ [e.target.name]: e.target.value });
  }

  componentWillMount() {
    this.props.getAllCountry();
  }

  closeCompanyUserSub() {
    this.context.router.history.push('/profile');
  }

  verifyEmail() {
    this.props.checkEmailVerify({ email: this.state.email });
  }

  _countrySelect(e) {
    this.setState({ countryCode: e.value });
  }

  handleSubUsers(e) {
    e.preventDefault();
    if (this.isValid()) {
      this.setState({ errors: {}, isLoader: true, saveProfileAState: true });
      // this.props.requestApiData(this.state);
      this.props.submitSubUser(this.state);
    }
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  componentWillUnmount () {
    const {submitSubUserClear} = this.props
    submitSubUserClear()

  }

  validateInput(data) {
    const errors = {};
    const isemailVerified = this.props.data.emailVerifyData;
    if (Object.keys(isemailVerified).length > 0) {
      if (isemailVerified.collectMessage.messageShort === 'User email already exist') {
        errors.email = 'This user\'s email address has already been added to Collectively';
      }
    }
    if (!data.firstname) {
      errors.firstName = 'First name is required';
      errors.firstNameError = true;
    } else if (data.firstname.length < 2 || data.firstname.length > 20) {
      errors.firstName = 'First name should be between 2 to 20 characters';
      errors.firstNameError = true;
    }
    if (!data.lastname) {
      errors.lastname = 'Last name is required';
      errors.lastNameError = true;
    } else if (data.lastname.length < 2 || data.lastname.length > 20) {
      errors.lastname = 'Last name should be between 2 to 20 characters';
      errors.lastNameError = true;
    }

    if (!data.countryCode) {
      errors.countryCode = 'Coutry code is required';
      errors.countryCodeError = true;
    }

    if (!data.phone) {
      errors.phone = 'Mobile number is required';
      errors.newMobilePhoneError = true;
    } else if (data.phone.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.phone = 'Please enter at least 10 digit';
      errors.newMobilePhoneError = true;
    }
    if (!Validator.isEmail(data.email)) {
      errors.email = 'Email is Not Valid';
      errors.emailError = true;
    }
    if (Validator.isEmpty(data.email)) {
      errors.email = 'Email is required';
      errors.emailError = true;
    }

    // if (Validator.isEmpty(data.password)) {
    //   errors.password = 'Password is required';
    //   errors.passwordError = true;
    // }
    // const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    // // const re = new RegExp("^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$");
    // if (!re.test(data.password)) {
    //   errors.password = 'Password must have 1 capital letter ,1 small letter ,1 special characters ,1 number and at least 8 char.';
    //   errors.passwordError = true;
    // }

    return {
      errors,
      isValid: isEmpty(errors),
    };
  }

  componentDidUpdate() {
    const { GetAffiliateSubUser } = this.props.data;
    const { GetAffiliateSubUser1 } = this.state;

      if (GetAffiliateSubUser !== undefined) {
        if (GetAffiliateSubUser1 !== GetAffiliateSubUser) {
          this.setState({
            GetAffiliateSubUser1: GetAffiliateSubUser,
            isLoader: false,
          }, async () => {
            if(GetAffiliateSubUser.code === 200) {
              await this.props.getAffiliateUser(localStorage.getItem('userId'));
              await this.context.router.history.push('/profile');
              }
          });
          // toast.info('User profile saved successfully!', {
          //   position: toast.POSITION.TOP_CENTER,
          // });
          // setTimeout(() => {
          //   this.context.router.history.push('/profile');
          //   // this.props.getBusinessSubUserById({ businessSubUserId: this.props.subUserId });
          // }, 2000);


          // this.context.router.history.push('/manageSubUsersBusiness')
        }
      }
    // this.context.router.history.push('/manageSubUsers')
  }

  componentWillReceiveProps() {
    // let receivedUser = nextProps.data.GetAffiliateSubUser;
    // //this.context.router.history.push('/manageSubUsers')
  //       let getAffiliateSubUser = nextProps.data.GetAffiliateSubUser;
  //       console.log(['GetAffiliateSubUser', getAffiliateSubUser]);
  //       if (getAffiliateSubUser.code === 200) {
  //           this.context.router.history.push('/profile')
  //       }
  }

  render() {
    const {
      errors, email, isLoader, firstname,
      // password, 
      lastname, phone, countryCode,
    } = this.state;
    const { AllCountryData } = this.props.data;
    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map(item => optionsCountry.push({ value: item.countryCode, label: item.countryCode, name: item.countryCode }));
    } else {
      optionsCountry.push({ value: '+1', label: '+1', name: '+1' });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: countryCode });
    const cDefaultOptionCountry = cSelectedCountry;
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    return (
      <span>
        {loader1}
        <div>


          <div className="main-content shadow-none">
            <div className="tab-inner">
              <div className="row">
                <div className="">
                  <div className="welcome-partner">
                    <div className="">
                      <h5 className="tab-heading blue-heading">Add sub user</h5>
                      <form  onSubmit={this.handleSubUsers}>
                        <div className="row profile-formmain">
                          <div className="input-field col s6">
                            <TextFieldGroup
                              field="firstname"
                              label="First Name*"
                              value={firstname}
                              error={errors.firstName}
                              onChange={this.onChange}
                            />

                          </div>

                          <div className="input-field col s6">
                            <TextFieldGroup
                              field="lastname"
                              label="Last Name*"
                              value={lastname}
                              error={errors.lastname}
                              onChange={this.onChange}
                            />

                          </div>
                          <div className=" col s6 phone-signupnew">
                            <div className="input-field col s5 input-field tel-input-lt" style={{ paddingLeft: 0 }}>
                              <label className="active country-code">Country Code</label>
                              <Dropdown
                                name="cState"
                                className="browser-default"
                                options={optionsCountry}
                                onChange={this._countrySelect}
                                value={cDefaultOptionCountry}
                                placeholder="Select an option"
                              />
                              <span className={errors.countryCodeError ? 'show invalid' : 'hide'}>{errors.countryCode}</span>

                            </div>

                            <div className="col s7 input-field tel-input-rt">
                              <MaskInputNumber
                                field="phone"
                                label="Phone number*"
                                value={phone}
                                error={errors.phone}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>

                          <div className="input-field col s6">
                            <TextFieldGroup
                              field="email"
                              label="Email Id*"
                              value={email}
                              error={errors.email}
                              checkUserExists={this.verifyEmail}
                              onChange={this.onChange}
                            />
                          </div>
                          {/* <div className="input-field col s6 clear password-field">
                            <TextFieldGroup
                              field="password"
                              label="Password*"
                              value={password}
                              error={errors.password}
                              onChange={this.onChange}
                              type="password"
                            />
                          </div> */}

                        </div>
                       
                        <div className="btn-outer">
                            <button type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new">
                                Save Sub User
                              {' '}
                            </button>
                            <button onClick={this.closeCompanyUserSub} type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new">
                                Cancel
                              {' '}
                            </button>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>

    );
  }
}

SubuserAffiliate.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ submitSubUser, checkEmailVerify, getAllCountry , getAffiliateUser, submitSubUserClear }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(SubuserAffiliate));
